"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.X_OFFSET_TIME_SCALE = exports.TIME_SCALE_RATE_OF_CHANGE = exports.SECONDS_PER_ACTIVE_STUDENT = exports.MIN_TIME_SCALE = exports.MAP_OBJECT_SCAN_SPEED_PER_STUDENT = void 0;
exports.getScanTimeScale = getScanTimeScale;
const MIN_TIME_SCALE = exports.MIN_TIME_SCALE = 0.1; // Don't scale sensor times smaller than 1/10th time
const TIME_SCALE_RATE_OF_CHANGE = exports.TIME_SCALE_RATE_OF_CHANGE = -1.4; // rate of time drop off for sensors as proportion exceeds 25%
const X_OFFSET_TIME_SCALE = exports.X_OFFSET_TIME_SCALE = 1.25; // start drop at 25% of class participating
const MAP_OBJECT_SCAN_SPEED_PER_STUDENT = exports.MAP_OBJECT_SCAN_SPEED_PER_STUDENT = 1;
const SECONDS_PER_ACTIVE_STUDENT = exports.SECONDS_PER_ACTIVE_STUDENT = 40;

/**
 * Returns a decimal number between 1 and .1 scaling down the total time required to complete a scan
 * Calculated from the proportion of students (including students with boost active) scanning to active students
 */
function getScanTimeScale(studentScanningSpeed, activeStudentCount) {
  return studentScanningSpeed > MAP_OBJECT_SCAN_SPEED_PER_STUDENT ? Math.min(1, Math.max(MIN_TIME_SCALE, TIME_SCALE_RATE_OF_CHANGE * (studentScanningSpeed / activeStudentCount) + X_OFFSET_TIME_SCALE)) : 1;
}